import React from 'react';
import { useSelector } from 'react-redux';

import { MachineSetup } from 'components/MachineSetup';
import { JOB_STATUSES } from 'lib/constants';
import { getJobStatus } from 'lib/selectors/getJobStatus';
import { getHasOpenActivitySetInSetup } from 'lib/selectors/getHasOpenActivitySetInSetup';

import { getIsUnknownJob } from 'lib/selectors/getIsUnknownJob';
import { getIsWaitingForWork } from 'lib/selectors/getIsWaitingForWork';
import WaitingForWork from 'pages/Machine/MachineMainWrapper/WaitingForWork';
import UnknownJob from 'pages/Machine/MachineMainWrapper/UnknownJob';
import { PartCount } from './PartCount';

const MachineStatus = () => {
  const jobStatus = useSelector(getJobStatus);
  const hasOpenActivitySetInSetup = useSelector(getHasOpenActivitySetInSetup);
  const isSetup = hasOpenActivitySetInSetup || jobStatus === JOB_STATUSES.SETUP;

  const isWaitingForWork = useSelector(getIsWaitingForWork);
  const isUnknownJob = useSelector(getIsUnknownJob);

  if (isWaitingForWork) {
    return <WaitingForWork />;
  }

  if (isUnknownJob) {
    return <UnknownJob />;
  }

  if (isSetup) {
    return <MachineSetup />;
  }

  return <PartCount />;
};

export { MachineStatus };
